import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import { LenderAction, useLenderProvider } from '../Lender.Hooks';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function LenderList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = useLenderProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.lenders}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th></th>
          <th>{lang.name}</th>
          <th>{lang.address}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: lender }) => (
            <tr key={lender.id}>
              <td width="1%">
                {lender?.isInactive ? (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.error, backgroundColor: Theme.Color.errorLight }}
                  >
                    <Icon class="fas-ban" />
                    &nbsp;{lang.inactive}
                  </Box>
                ) : (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.success, backgroundColor: Theme.Color.successLight }}
                  >
                    <Icon class="fas-check" />
                    &nbsp;{lang.active}
                  </Box>
                )}
              </td>
              <td>
                <b>{lender.name}</b>
              </td>
              <td>{lender.fullAddress}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lender.id.toString(),
                      action: LenderAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LENDER}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lender.id.toString(),
                      action: LenderAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LENDER}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
